/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Insufficient_LinkInputs */

const cs_billing_insufficient_link = /** @type {(inputs: Billing_Insufficient_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít kredity`)
};

const en_billing_insufficient_link = /** @type {(inputs: Billing_Insufficient_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open credits`)
};

/**
* | output |
* | --- |
* | "Open credits" |
*
* @param {Billing_Insufficient_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_insufficient_link = /** @type {((inputs?: Billing_Insufficient_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Insufficient_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_insufficient_link(inputs)
	return cs_billing_insufficient_link(inputs)
});